import React, { useContext, useState } from 'react'
import { Dispatch, RootState } from '../../store/store';
import { connect } from 'react-redux';
import MetaFieldsV2 from '../MetaFieldsV2';
import { useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { AbilityContext } from '../Can/Can';
import { Action } from '../../enums/action';
import { ACTION_BY_PAGE, PAGE_TITLE } from '../../constants/common';

interface DefaultMetaFieldsV2Props extends ReturnType<typeof mapState>, ReturnType<typeof mapDispatch> { }

const DefaultMetaFieldsV2: React.FC<DefaultMetaFieldsV2Props> = ({
  createMetaField,
  deleteMetaField,
  updateListMetaFields,
  setMetaFields,
  metaFields,
  getMetaFields,
  saveAsClientDefault,
}) => {
  const { id } = useParams();
  const { t } = useTranslation();
  const ability = useContext(AbilityContext);
  const [isLoading, setIsLoading] = useState(false);

  const handleSaveAsClientDefault = async () => {
    try {
      setIsLoading(true);
      await saveAsClientDefault(id);
    } finally {
      setIsLoading(false);
    }
  };

  const buttons = ability.can(Action.Update, ACTION_BY_PAGE[PAGE_TITLE.EDIT_CONTRACT].SAVE_AS_CLIENT_DEFAULT)
    ? [
      <button
        key="save-as-client-default"
        onClick={handleSaveAsClientDefault}
        className="inline-flex items-center justify-center rounded-md bg-meta-3 px-6 text-center font-medium text-white hover:bg-opacity-90 disabled:opacity-50"
      >
        {t('buttons.saveAsClientDefault')}
      </button>,
    ]
    : [];

  return (
    <div className="c-default-meta-fields c-default-meta-fields_v2">
      <MetaFieldsV2
        id={id}
        createMetaField={createMetaField}
        deleteMetaField={deleteMetaField}
        metaFields={metaFields}
        onChangeListMetaFields={setMetaFields}
        title='Default meta fields'
        updateListMetaFields={updateListMetaFields}
        getMetaFields={getMetaFields}
        isCustomLoading={isLoading}
        buttons={buttons}
      />
    </div>
  )
};

const mapState = (state: RootState) => ({
  metaFields: state.contract_meta_fields.metaFields,
});

const mapDispatch = (dispatch: Dispatch) => ({
  createMetaField: dispatch.contract_meta_fields.createMetaField,
  deleteMetaField: dispatch.contract_meta_fields.deleteMetaField,
  updateListMetaFields: dispatch.contract_meta_fields.updateListMetaFields,
  setMetaFields: dispatch.contract_meta_fields.setList,
  getMetaFields: dispatch.contract_meta_fields.getMetaFields,
  saveAsClientDefault: dispatch.contract_meta_fields.saveAsClientDefault,
});

export default connect(mapState, mapDispatch)(DefaultMetaFieldsV2);
